import freeEmailDomains from 'free-email-domains'

/**
 * Get clearbit logo url from company url
 * This will also
 * @param companyUrl Company url to load logo for
 * @param size Logo size (Optional)
 * @returns Clearbit logo url if company url is valid, else null
 */
export const getClearbitLogo = (companyUrl: string | null, size?: number): string | null => {
  if (!companyUrl) {
    return null
  }
  if (freeEmailDomains.includes(companyUrl)) {
    return null
  }
  const baseUrl = `//logo.clearbit.com/${companyUrl}`
  if (size) {
    return baseUrl + `?size=${size}`
  }
  return baseUrl
}
